'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignInModal = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Form = require('web-makeup/dist/Form');

var _Form2 = _interopRequireDefault(_Form);

var _Input = require('web-makeup/dist/Input');

var _Input2 = _interopRequireDefault(_Input);

var _reactHooks = require('@apollo/react-hooks');

var _typography = require('web-makeup/dist/design-system/styles/typography');

var _spacings = require('web-makeup/dist/design-system/styles/spacings');

var _mutations = require('../../graphql/mutations');

var _apolloClient = require('../../config/apolloClient');

var _signInModal = require('./sign-in-modal.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignInModalWithForm = function SignInModalWithForm(_a) {
    var form = _a.form,
        isVisible = _a.isVisible,
        setIsVisible = _a.setIsVisible;
    var _b = _react2.default.useState(false),
        isPasswordVisible = _b[0],
        setIsPasswordVisible = _b[1];
    var _c = _react2.default.useState(false),
        hasError = _c[0],
        setHasError = _c[1];
    var getFieldDecorator = form.getFieldDecorator;
    var handleOk = function handleOk() {
        return setIsVisible(false);
    };
    var handleCancel = function handleCancel() {
        return setIsVisible(false);
    };
    var afterSignIn = function afterSignIn(data) {
        if (!data) {
            setHasError(true);
        }
        if (data && 'signIn' in data) {
            var _a = data.signIn,
                token = _a.token,
                userId = _a.userId;
            if (token) {
                localStorage.setItem('orderToken', token);
                localStorage.setItem('orderUserId', userId);
                setIsVisible(false);
            }
        }
    };
    var signIn = (0, _reactHooks.useMutation)(_mutations.ORDER_SIGNIN, {
        client: _apolloClient.apolloClient,
        onCompleted: function onCompleted(data) {
            return afterSignIn(data);
        },
        onError: function onError() {
            return setHasError(true);
        }
    })[0];
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        form.validateFields(function (err, values) {
            if (values && values.email && values.password) {
                signIn({ variables: { email: values.email, password: values.password } });
            }
        });
    };
    return _react2.default.createElement(_signInModal.StyledModal, { title: "", footer: null, visible: isVisible, onOk: handleOk, onCancel: handleCancel }, _react2.default.createElement(_signInModal.StyledModalBodyContainer, null, _react2.default.createElement(_signInModal.StyledFlexBox, null, _react2.default.createElement(_spacings.Margin, { bottom: true, size: "xxSmall" }, _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h1", color: "black1", fontWeight: "black" }, "Log into your 90 Seconds account")), _react2.default.createElement(_signInModal.StyledModalCloseButton, { as: "a", fontSize: "h5", color: "black1", onClick: handleCancel }, "Close")), _react2.default.createElement(_spacings.Margin, { bottom: true, size: "medium" }, _react2.default.createElement(_signInModal.StyledModalHeaderSubContainer, null, _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h4", color: "black1" }, "Fill your information below or continue with your social media account to log in 90 Seconds."))), _react2.default.createElement(_spacings.Margin, { bottom: true, size: "medium" }, _react2.default.createElement(_signInModal.StyledIconFlexBox, null, _react2.default.createElement(_spacings.Margin, { right: true, size: "medium" }, _react2.default.createElement(_signInModal.IconBox, { backgroundColor: "#000000", backgroundImage: "https://res.cloudinary.com/ninety-seconds/image/upload/v1591868066/-mobile/button-apple.svg" })), _react2.default.createElement(_spacings.Margin, { right: true, size: "medium" }, _react2.default.createElement(_signInModal.IconBox, { backgroundColor: "#1877F2", backgroundImage: "https://res.cloudinary.com/ninety-seconds/image/upload/v1591868066/-mobile/button-facebook.svg" })), _react2.default.createElement(_signInModal.IconBox, { backgroundColor: "#0077B5", backgroundImage: "https://res.cloudinary.com/ninety-seconds/image/upload/v1591868066/-mobile/button-linkedin.svg" }))), _react2.default.createElement(_signInModal.Divider, null), _react2.default.createElement(_spacings.Margin, { top: true, size: "medium" }, _react2.default.createElement(_Form2.default, { onSubmit: handleSubmit }, _react2.default.createElement(_spacings.Margin, { bottom: true, size: "xSmall" }, "Email"), _react2.default.createElement(_signInModal.StyledFormItem, { hasError: hasError }, getFieldDecorator('email', {
        rules: []
    })(_react2.default.createElement(_Input2.default, { size: "large", type: "email", placeholder: "Enter your email address" }))), _react2.default.createElement(_spacings.Margin, { bottom: true, size: "xSmall" }, "Password"), _react2.default.createElement(_signInModal.StyledFormItem, { noMarginBottom: true, hasError: hasError }, getFieldDecorator('password', {
        rules: []
    })(_react2.default.createElement(_Input2.default, { size: "large", type: isPasswordVisible ? 'text' : 'password', placeholder: "Enter your password", suffix: isPasswordVisible ? _react2.default.createElement(_signInModal.StyledPasswordIcon, { type: "eye-invisible", onClick: function onClick() {
                return setIsPasswordVisible(false);
            } }) : _react2.default.createElement(_signInModal.StyledPasswordIcon, { type: "eye", onClick: function onClick() {
                return setIsPasswordVisible(true);
            } }) }))), _react2.default.createElement(_spacings.Margin, { top: true, size: "mSmall" }, _react2.default.createElement(_spacings.Margin, { bottom: true, size: "small" }, _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h6", color: "alert" }, hasError ? 'Email/Password combination is not valid' : ' '))), _react2.default.createElement(_Form2.default.Item, null, _react2.default.createElement(_signInModal.StyledFlexBox, null, getFieldDecorator('remember', {
        valuePropName: 'checked',
        initialValue: true
    })(_react2.default.createElement(_signInModal.StyledCheckbox, null, "Remember me")), _react2.default.createElement("a", { href: "" }, "Forgot password?"))), _react2.default.createElement(_Form2.default.Item, null, _react2.default.createElement(_signInModal.StyledButton, { type: "primary", htmlType: "submit" }, "Log in")))), _react2.default.createElement(_spacings.Margin, { top: true, bottom: true, size: "medium" }, _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h5", color: "black1", textAlign: "center" }, 'Don\u2019t have an account?'), _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h5", color: "black1", textAlign: "center" }, _react2.default.createElement("b", null, "Sign up as brand"), " or ", _react2.default.createElement("b", null, "Sign up as creator")))), _react2.default.createElement(_signInModal.StyledModalFooterContainer, null, _react2.default.createElement(_signInModal.StyledFlexBox, null, _react2.default.createElement("div", null, _react2.default.createElement(_signInModal.StyledModalFooterText, { as: "span", fontSize: "h6", color: "black1", fontWeight: "bold" }, "English"), _react2.default.createElement(_typography.Text, { as: "span", fontSize: "h6", color: "saruman" }, '\u65E5\u672C\u8A9E')), _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h6", color: "black1" }, "View support articles"))));
};
var SignInModal = exports.SignInModal = _react2.default.memo(_Form2.default.create()(SignInModalWithForm));
//# sourceMappingURL=sign-in-modal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/components/sign-in-modal/sign-in-modal.js
// module id = 1878
// module chunks = 0